import { render, staticRenderFns } from "./ReconArrearShare.vue?vue&type=template&id=71fb4e0d&scoped=true&"
import script from "./ReconArrearShare.vue?vue&type=script&lang=js&"
export * from "./ReconArrearShare.vue?vue&type=script&lang=js&"
import style0 from "./ReconArrearShare.vue?vue&type=style&index=0&id=71fb4e0d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb4e0d",
  null
  
)

export default component.exports